import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NewsItemState } from '../reducers/news-item.reducer';
import { NEWS_ITEM_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<NewsItemState>(NEWS_ITEM_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: NewsItemState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: NewsItemState) => state.loading);
export const selectSaving = createSelector(selectState, (state: NewsItemState) => state.saving);
export const selectSaved = createSelector(selectState, (state: NewsItemState) => state.saved);
export const selectError = createSelector(selectState, (state: NewsItemState) => state.error);
export const selectNewsItem = createSelector(selectState, (state: NewsItemState) => state.newsItem);
